import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import { useTable, useSortBy, useFilters, useGlobalFilter } from "react-table";

const Commissiontable = ({ columns, data }) => {
  // console.log(data);
  const [currentRow, setCurrentRow] = useState(0);
  const [selectedSortOption] = useState("");
  const [filteredTableData, setFilteredTableData] = useState(data);
  const itemsPerPage = 1; // Display one row at a time

  //ช่องค้นหาตารางรายละเอียดรายได้

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable(
      {
        columns,
        data: filteredTableData, // Use filteredTableData here
        initialState: {
          sortBy: selectedSortOption
            ? [{ id: selectedSortOption, desc: true }]
            : [],
        },
      },
      useFilters,
      useGlobalFilter,
      useSortBy,
    );
  const RowCount = Math.ceil(rows.length / itemsPerPage);
  const displayRows = rows.slice(0, (currentRow + 1) * itemsPerPage);
  useEffect(() => {
    // Initialize the table with all data when the component mounts
    setFilteredTableData(data);
  }, [data]);

  useEffect(() => {
    if (currentRow < RowCount - 1) {
      const timer = setTimeout(() => {
        setCurrentRow(currentRow + 1);
      }, 40); // Delay in milliseconds between rendering each row

      return () => clearTimeout(timer);
    }
  }, [currentRow, RowCount]);

  return (
    <div>
      <div className="rounded overflow-x-auto mt-1">
        <Table
          {...getTableProps()}
          className="w-full"
          sx={{ borderCollapse: "separate", borderSpacing: 0 }}
        >
          <thead>
            {headerGroups.map((headerGroup) => {
              const { key: hgKey, ...hgProps } =
                headerGroup.getHeaderGroupProps();
              return (
                <tr key={hgKey} {...hgProps} className="bg-gray-100">
                  {headerGroup.headers.map((column) => {
                    const { key: colKey, ...colProps } = column.getHeaderProps(
                      column.getSortByToggleProps(),
                    );
                    return (
                      <th
                        key={colKey}
                        {...colProps}
                        className={`py-0.5 px-1 text-xs ${column.widthClass} ${
                          column.sticky ? "sticky z-20 bg-gray-100" : ""
                        }`}
                        align={column.align}
                        style={{
                          ...(column.width
                            ? {
                                width: column.width,
                                minWidth: column.width,
                                maxWidth: column.width,
                              }
                            : {}),
                          ...(column.sticky
                            ? { left: column.stickyLeft ?? 0 }
                            : {}),
                          ...(column.stickyShadow
                            ? { boxShadow: "4px 0 8px -1px rgba(0,0,0,0.55)" }
                            : {}),
                        }}
                      >
                        {column.render("Header")}
                      </th>
                    );
                  })}
                </tr>
              );
            })}
          </thead>
          <tbody {...getTableBodyProps()}>
            {displayRows.map((row, index) => {
              prepareRow(row);
              const { key: rowKey, ...rowProps } = row.getRowProps();
              const rowClassName =
                index % 2 === 0 ? "bg-gray-50" : "bg-gray-200";
              return (
                <tr
                  key={rowKey}
                  {...rowProps}
                  className={`transition-colors ${rowClassName} hover:bg-gray-300`}
                >
                  {row.cells.map((cell) => {
                    const { key: cellKey, ...cellProps } = cell.getCellProps();
                    return (
                      <td
                        key={cellKey}
                        {...cellProps}
                        className={`py-0.5 px-1 text-xs ${cell.column.widthClass} ${
                          cell.column.sticky
                            ? `sticky z-10 ${rowClassName}`
                            : ""
                        }`}
                        align={cell.column.align}
                        style={{
                          ...(cell.column.width
                            ? {
                                width: cell.column.width,
                                minWidth: cell.column.width,
                                maxWidth: cell.column.width,
                              }
                            : {}),
                          ...(cell.column.sticky
                            ? { left: cell.column.stickyLeft ?? 0 }
                            : {}),
                          ...(cell.column.stickyShadow
                            ? { boxShadow: "4px 0 8px -1px rgba(0,0,0,0.55)" }
                            : {}),
                        }}
                      >
                        {cell.render("Cell")}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default Commissiontable;
